import { Button, Form, Input } from 'antd';
import React, { useRef } from 'react';
import { useLangsState } from './State';

function Add() {
    const formRef = useRef();
    let { addNashr } = useLangsState()
    
    const handleFinish = (values) => {
        addNashr(values);
        formRef.current?.resetFields();
    }
    
    return (
        <Form
            ref={formRef}
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={handleFinish}
            autoComplete="off"
        >
            <Form.Item label="Til nomi" name={'til'}>
                <Input />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">Saqlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;